import {useEffect} from 'react';

export const FILTER_AND_SORT_FAB_X_OFFSET_CSS_VARIABLE =
  '--filter-and-sort-fab-x-offset';
export const FILTER_AND_SORT_FAB_Y_OFFSET_CSS_VARIABLE =
  '--filter-and-sort-fab-y-offset';

export const useFilterAndSortFABOffset = () => {
  useEffect(() => {
    return () => {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setFilterAndSortFABOffset({axis: 'x', offset: undefined});
      setFilterAndSortFABOffset({axis: 'y', offset: undefined});
    };
  }, []);

  return {setFilterAndSortFABOffset};
};

const setFilterAndSortFABOffset = ({
  axis,
  offset,
}: {
  axis: 'x' | 'y';
  offset: string | undefined;
}) => {
  const filterAndSortFABCssVariable =
    axis === 'x'
      ? FILTER_AND_SORT_FAB_X_OFFSET_CSS_VARIABLE
      : FILTER_AND_SORT_FAB_Y_OFFSET_CSS_VARIABLE;

  if (!offset) {
    document.documentElement.style.removeProperty(filterAndSortFABCssVariable);
    return;
  }

  document.documentElement.style.setProperty(
    filterAndSortFABCssVariable,
    offset,
  );
};
